// import { setPaginate } from '@/hooks/setPage'
import React from 'react'

type paginationProps = {
  pages: number
  startIdx: number
  currentPageIdx: number
  setPage: Function
  setCurrentIndex: Function
}

type paginationItemProps = {
  pages: number
  currentPageIdx: number
  key: number | string
  idx: number
  content: string
  setPage: Function
  setCurrentIndex: Function
}

const PaginationItem = ({ idx, pages, currentPageIdx, content, setPage, setCurrentIndex }: paginationItemProps) => {
  const disabled = (idx < 0 ) || (idx >= pages) || (idx === currentPageIdx) ? true : false
  let iconHTML = ''
  let contentHTML = ''
  let buttonHTML = ''

  if (content === 'next') {
    iconHTML = `<span class="material-icons" aria-hidden="true" aria-label="Go to next page">arrow_forward_ios</span>`
  } else if (content === 'prev') {
    iconHTML = `<span class="material-icons" aria-hidden="true" aria-label="Go to previous page">arrow_back_ios</span>`
  } else {
    buttonHTML = `<span>${idx + 1}</span>`
  }

  return (
    <li>
      <button
        type="button"
        className="sopa--poi-pagination_item"
        disabled={disabled}
        onClick={() => {
          setCurrentIndex(idx)
          setPage(idx)
        }}
        dangerouslySetInnerHTML={{ __html: `${iconHTML}${buttonHTML}` }}
      />
    </li>
  )
}

const Pagination = ({ setPage, setCurrentIndex, pages, currentPageIdx, startIdx }: paginationProps) => {
  const rows = [];
  rows.push(<PaginationItem currentPageIdx={currentPageIdx} pages={pages} setCurrentIndex={setCurrentIndex} setPage={setPage} key={'prev'} idx={(currentPageIdx - 1)} content={'prev'} />);

  for (let i = 0; i < pages; i++) {
    rows.push(<PaginationItem currentPageIdx={currentPageIdx} pages={pages} setCurrentIndex={setCurrentIndex} setPage={setPage} key={i} idx={i} content={`${i + 1}`} />);
  }
  rows.push(<PaginationItem currentPageIdx={currentPageIdx} pages={pages} setCurrentIndex={setCurrentIndex} setPage={setPage} key={'next'} idx={(currentPageIdx + 1)} content={'next'} />);

  return (
    <>
      <nav>
        <ul className="sopa--poi-pagination">
          {rows}
        </ul>
      </nav>
    </>
  )
}

export default Pagination
